import i18n from "../../i18next/i18next";

export const billingType = [{
    value: "constant",
    name: i18n.t("global:servicevaluation.constant"),
}, {
    value: "rateOneKm",
    name: i18n.t("global:servicevaluation.rateOneKm"),
}
];